import { reactive } from "vue";
import {base_url} from './mock.js'

export const AccountStore = reactive({
  accountInfo: null,
  accountBindInfo: null,

  isUserLoginStatus:false,
  lastGetUserInfoTime: 0, // 新增字段，记录上次请求时间
  async fetchUserInfo() {
    if( this.accountInfo==null){
      const result = await this.isUserLogin();
      this.accountInfo = result;
    }
    await this.getUserInfo();
  },

  setUserLoginStatus(value) {
    this.isUserLoginStatus = value;
  },

  async isUserLogin() {

    var userData = localStorage.getItem("bee_user_login_status", null);
    if (userData != null && userData!=undefined) {
      this.setUserLoginStatus(true);
      return JSON.parse(userData);
    }

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', // 如果发送JSON数据
        },
        body: new URLSearchParams({
            action: 'io_bee_login_status',
            _wpnonce: "wp_nonce",
        }),
    };

    const userIsLogin = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
    // console.log(userIsLogin);
    let data = await userIsLogin.json()
   
    if (data.data.code == 200) {
      this.setUserLoginStatus(true)
    }else{
      this.setUserLoginStatus(false)
    } 
    return data.data;
},



async getUserInfo() {
  const now = Date.now();
  if (now - this.lastGetUserInfoTime < 5000) {
    // 20秒内不重复请求
    return;
  }
  this.lastGetUserInfoTime = now;
  let localInviteCode = localStorage.getItem('inviteCode')
  if (localInviteCode == undefined || localInviteCode == null ) {
    localInviteCode = "";
  }
  // 如果localInviteCode以"#/"结尾，则去除
  if (typeof localInviteCode === 'string' && localInviteCode.endsWith('#/')) {
    localInviteCode = localInviteCode.slice(0, -2);
  }
    var e_mail = "";
    var userData = localStorage.getItem("bee_user_login_status", null);
    if (userData != null && userData!=undefined) {
      const user = JSON.parse(userData);
     e_mail = user.user.email;
    }

  const options = {
      method: 'POST',
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', 
      },
      body: new URLSearchParams({
          action: 'bee_getUserInfo',
          _wpnonce: "wp_nonce",
          inviteCode:localInviteCode,
          userInfo: e_mail,
      }),
  };

  const userInfoData = await fetch(`${base_url()}/wp-admin/admin-ajax.php`, options)
  // console.log(userInfoData);
  let r_data = await userInfoData.json()
  let wp_data = r_data.data.data;
  let json = JSON.parse(wp_data);
  // console.log(json.data)
  this.accountBindInfo = json.data;
  // console.log(this.accountBindInfo)
   },


});
